import React from "react";
import Container from "../common/Container";
import { FaTwitter, FaLinkedin, FaGithub } from "react-icons/fa";

const teamMembers = [
  {
    name: "Seyed Mojtaba Hosseini, Ph.D",
    role: "Co-Founder / Project Manager",
    affiliation: "Masaryk University",
    twitter: "https://x.com/smhbamakan",
    linkedin: "https://www.linkedin.com/in/smhbamakan/",
  },
  {
    name: "Mohammadsadegh Solouki",
    role: "Co-Founder / Product Manager",
    affiliation: "Canadian University Dubai",
    linkedin: "https://www.linkedin.com/in/mohamadsolouki/",
    github: "https://github.com/mohamadsolouki",
  },
  {
    name: "Amirhoseein Azarpour",
    role: "Tech Lead",
    affiliation: "",
    twitter: "https://x.com/7Amirhossein8",
    github: "https://github.com/AmirH-A",
  },
  {
    name: "Swift Evo",
    role: "Business Development Manager",
    affiliation: "",
    twitter: "https://x.com/swiftevo1",
    github: "https://github.com/Swiftevo",
  },
];

const TeamMemberCard = ({ member }) => {
  return (
    <div className="group relative bg-white/5 backdrop-blur-md rounded-2xl p-6 border border-white/10 hover:border-primary/30 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10 hover:-translate-y-1">
      {/* Avatar */}
      <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-gradient-to-br from-primary to-primary-green p-1">
        <div className="w-full h-full rounded-full bg-gradient-to-br from-primary/20 to-primary-green/20 flex items-center justify-center overflow-hidden">
          {member.image ? (
            <img src={member.image} alt={member.name} className="w-full h-full object-cover rounded-full" />
          ) : (
            <span className="text-3xl font-bold text-white">
              {member.name.split(" ").map(n => n[0]).join("").slice(0, 2)}
            </span>
          )}
        </div>
      </div>
      
      <h3 className="text-lg font-semibold text-white text-center mb-1">
        {member.name}
      </h3>
      <p className="text-primary-green text-sm text-center mb-1">
        {member.role}
      </p>
      {member.affiliation && (
        <p className="text-white/50 text-xs text-center mb-4">
          {member.affiliation}
        </p>
      )}
      
      {/* Social Links */}
      <div className="flex justify-center gap-3 mt-4">
        {member.twitter && (
          <a
            href={member.twitter}
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-primary hover:text-white transition-all duration-300"
          >
            <FaTwitter size={14} />
          </a>
        )}
        {member.linkedin && (
          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-primary hover:text-white transition-all duration-300"
          >
            <FaLinkedin size={14} />
          </a>
        )}
        {member.github && (
          <a
            href={member.github}
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-primary hover:text-white transition-all duration-300"
          >
            <FaGithub size={14} />
          </a>
        )}
      </div>
    </div>
  );
};

const TeamSection = () => {
  return (
    <section className="w-full py-20 lg:py-28 bg-gradient-to-b from-secondary via-[#1a1230] to-secondary relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-transparent to-transparent pointer-events-none"></div>
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary/30 to-transparent"></div>
      <div className="absolute top-1/4 -left-40 w-96 h-96 bg-primary/5 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 -right-40 w-80 h-80 bg-primary-green/5 rounded-full blur-[100px] pointer-events-none"></div>
      
      <Container className="relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Our Team
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white abel-font mb-4">
            Meet Our Team
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-lg">
            Where curiosity meets innovation, and the boundaries of knowledge are continuously pushed forward.
          </p>
        </div>
        
        {/* Core Team - 4 members centered */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {teamMembers.map((member, index) => (
            <TeamMemberCard key={index} member={member} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TeamSection;
